<div class = "my-container">
	<div style = "height:300px;" class = "form-box">
	  <h1 style = "text-align:center;margin-top:12px;">Sign In</h1>
	  <div class = "signForm">
			<div class="form-group">
			  <label for="exampleInputEmail1">Email address</label>
			  <input #email (keyup.enter)="updateEmail(email.value)" (blur) = "updateEmail(email.value)" type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email">
			</div>
			<div class="form-group">
			  <label for="exampleInputPassword1">Password</label>
			  <input #password (keyup.enter)="updatePassword(password.value)" (blur) = "updatePassword(password.value)" type="password" class="form-control" id="exampleInputPassword1" placeholder="Password">
			</div>
			<ng-container *ngIf = "this.clicked">
					<button style = "margin:0 auto;text-align:center;background-color:#6E1FD2;border-color:#6E1FD2;" class="btn btn-primary">
							<div class="spinner-border spinner-border-sm" role="status">
									<!-- <span class="sr-only">Loading...</span> -->
							</div>
					</button>
			</ng-container>
			<ng-container *ngIf = "!this.clicked">
					<button (click)="authenticateUser()" style = "margin:0 auto;text-align:center;background-color:#6E1FD2;border-color:#6E1FD2;" class="btn btn-primary">Sign In</button>
			</ng-container>
			
	  </div>
	</div>
	<div class = "alternate-box">
	  <div class = "prompt">
		<div>Don't have an account? <a style = "color:#6E1FD2;" routerLink = '/signup'>Sign up</a></div>
	  </div>
	</div>
  </div>